import { NgModule } from '@angular/core';
import { PagerComponent } from 'src/app/shared/components/pager/pager.component';
import { TypeIconComponent } from 'src/app/shared/components/type-icon/type-icon.component';
import { BlobUtilsModule } from '../blob-utils/blob-utils.module';
import { CopyTextModule } from './copy-text/copy-text.module';
import { DataFormComponent } from './data-form/data-form.component';
import { ValidationErrorsComponent } from './validation/validation-errors/validation-errors.component';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MiniTableComponent } from './mini-table/mini-table.component';
import { DashboardCardComponent } from './dashboard-card/dashboard-card.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { OverlayLoaderComponent } from './overlay-loader/overlay-loader.component';
import { SkeletonLoaderModule } from './skeleton-loader/skeleton-loader.module';
import { DashboardChartModule } from './dashboard-chart/dashboard-chart.module';
import { DashboardCardStatsPipe } from './dashboard-card/dashboard-card-stats.pipe';
import { UserTriggerInnerComponent } from './user-trigger-inner/user-trigger-inner.component';
import { AccountTriggerComponent } from './account-trigger/account-trigger.component';
import { ConfirmationModule } from './confirmation/confirmation.module';
import { DasboardCardSummaryModule } from './dashboard-card-summary/dashboard-card-summary.module';
import { SmallInfoBoxModule } from './small-info-box/small-info-box.module';
import { InitialsModule } from './initials/initials.module';
import { ImageInputComponent } from './image-input/image-input.component';
import { StatusToggleComponent } from './status-toggle/status-toggle.component';
import { RadioComponent } from './radio/radio.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { ImageModule } from '../images/images.module';
import { InputErrorIconComponent } from './input-error-icon/input-error-icon.component';
import { InlineMessageComponent } from './inline-message/inline-message.component';

@NgModule({
  declarations: [
    DataFormComponent,
    ValidationErrorsComponent,
    MiniTableComponent,
    DashboardCardComponent,
    OverlayLoaderComponent,
    DashboardCardStatsPipe,
    UserTriggerInnerComponent,
    AccountTriggerComponent,
    ImageInputComponent,
    ImagePreviewComponent,
    StatusToggleComponent,
    RadioComponent,
    InputErrorIconComponent,
    InlineMessageComponent,
  ],
  imports: [
    TranslateModule,
    InlineSVGModule,
    CommonModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    PagerComponent,
    SkeletonLoaderModule,
    DashboardChartModule,
    ConfirmationModule,
    DasboardCardSummaryModule,
    SmallInfoBoxModule,
    InitialsModule,
    BlobUtilsModule,
    CopyTextModule,
    TypeIconComponent,
    ImageModule,
  ],
  exports: [
    DataFormComponent,
    ValidationErrorsComponent,
    MiniTableComponent,
    DashboardCardComponent,
    DashboardChartModule,
    PagerComponent,
    OverlayLoaderComponent,
    SkeletonLoaderModule,
    UserTriggerInnerComponent,
    AccountTriggerComponent,
    ConfirmationModule,
    DasboardCardSummaryModule,
    SmallInfoBoxModule,
    InitialsModule,
    ImageInputComponent,
    ImagePreviewComponent,
    StatusToggleComponent,
    CopyTextModule,
    RadioComponent,
    DashboardCardStatsPipe,
    InputErrorIconComponent,
    InlineMessageComponent,
  ]
})
export class ComponentsModule {}
